<template>
    <div class="audit-equipment-status-badge">
        <b-badge v-if="auditEquipment" :variant="variant">{{ text }}</b-badge>
    </div>
</template>

<script>
import AuditEquipment from '@/models/AuditEquipment'

export default {
    name: 'AuditEquipmentStatusBadge',
    props: {
        auditEquipment: Object,
    },
    computed: {
        variant () {
            if (this.auditEquipment.status) {
                if (this.auditEquipment.status === 'NO_ISSUE') {
                    return 'primary'
                } else if (this.auditEquipment.status === 'RESOLVED') {
                    return 'success'
                } else if (this.auditEquipment.status === 'ISSUE') {
                    return 'warning'
                } else if (this.auditEquipment.status === 'VIOLATION') {
                    return 'danger'
                }
            }
            return ''
        },
        text () {
            let text = ''
            if (this.auditEquipment.status) {
                text = AuditEquipment.statusOptions[this.auditEquipment.status]
                // if(this.auditEquipment.status === 'ISSUE' || this.auditEquipment.status === 'VIOLATION') {
                //     text += ' - ' + AuditEquipment.categoryOptions[this.auditEquipment.category]
                // }
            }
            return text
        },
    }
}
</script>

<style scoped>

</style>